export const AUTH_TOKEN = 'sentry-a-token';
export const EXCLUDE_KEYS = ['notification', 'redirect'];
export const RENEWAL_TOKEN = 'sentry-a-r-token';
export const VUEX_STORE = 'sentry-f-a';
